export default __webpack_public_path__ + "static/media/school.e7036b08.svg";